export const SET_DOCUMENTS = 'documents/SET_DOCUMENTS';
export const UPDATE_DOCUMENT_PENDING = 'documents/UPDATE_DOCUMENT_PENDING';
